class HeaderSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['close', 'input']
  }

  static get requiredExternalElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.handleToggle = this.handleToggle.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handlePointerUp = this.handlePointerUp.bind(this)

    this.externalEls.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'pointerdown', this.handleToggle)
      this.listeners.add(triggerEl, 'pointerup', this.handlePointerUp)
    })

    this.listeners.add(this.els.close.element, 'click', this.handleClose)

    this.listeners.add(document, 'click', this.handleClick)
  }

  handlePointerUp () {
    this.focusInput()
  }

  handleToggle () {
    const searchClosed = this.getAttribute('aria-hidden') === 'true'

    this.setAttribute('aria-hidden', !searchClosed)

    document.body.classList.toggle(this.searchVisibleClassName, searchClosed)

    if (!searchClosed) return

    this.focusInput()
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')

    document.body.classList.remove(this.searchVisibleClassName)
  }

  handleClick (event) {
    if (event.target.closest(this.localName)) return
    if (event.target.closest(this.externalEls?.trigger?.selector)) return
    if (event.target.closest(this.els?.close?.selector)) return
    if (event.target.closest('[class*="klevu"]')) return
    this.handleClose()
  }

  focusInput () {
    this.els.input.element.focus()
  }

  get searchVisibleClassName () {
    return 'lyt-Header-searchVisible'
  }
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', HeaderSearch)
}
